import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/app/providers/AuthProvider';
import { canAccessPlatformAdmin } from './platformAdminAccess';

interface RequirePlatformAdminProps {
  children: React.ReactElement;
  area?: string;
}

/**
 * Protegge l'hub Amministrazione con il ruolo esplicito Platform Admin.
 * Il ruolo legacy resta gestito dal backend solo durante la compatibilità.
 */
const RequirePlatformAdmin: React.FC<RequirePlatformAdminProps> = ({ children, area }) => {
  const { user, loading, isPlatformAdmin, isSuperAdmin, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white to-zinc-50 dark:from-zinc-900 dark:to-zinc-800">
        <div className="w-12 h-12 border-3 border-zinc-200 dark:border-zinc-700 border-t-zinc-600 dark:border-t-zinc-400 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const legacyFallbackEnabled = import.meta.env.VITE_ALLOW_LEGACY_ADMIN_FALLBACK !== 'false';
  const hasAccess = canAccessPlatformAdmin({
    platformAccessVerified: user.platformAccessVerified,
    isSuperAdmin,
    isPlatformAdmin,
    platformAdminAreas: user.platformAdminAreas,
    isAdmin,
    isLegacyAdmin: user.isLegacyAdmin,
    legacyFallbackEnabled,
    requiredArea: area,
  });

  if (!hasAccess) {
    return <Navigate to="/forbidden" replace />;
  }

  return children;
};

export default RequirePlatformAdmin;
